export default __webpack_public_path__ + "static/media/alcatraz6.d62047ef.jpg";